export var MediaSettings={reposPath:'/repository/'};